import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';

export const LoyaltyIncentiveSwapDialog = ({
  isOpen,
  onClose,
  onSwap,
  incentiveType,
}: {
  isOpen: boolean;
  incentiveType: LoyaltyPromotionType;
  onClose: () => void;
  onSwap: () => void;
}) => {
  const { formatMessage } = useIntl();
  const isReward = incentiveType === LoyaltyPromotionType.REWARD;

  return (
    isOpen && (
      <Dialog
        showDialog={isOpen}
        heading={formatMessage(
          isReward
            ? { id: 'oneRewardPerOrder', defaultMessage: 'Only one reward per order' }
            : { id: 'oneOfferPerOrder', defaultMessage: 'Only one offer per order' }
        )}
        body={formatMessage(
          isReward
            ? {
                id: 'swapRewardText',
                defaultMessage: `You've already added an reward. Would you like to swap?`,
              }
            : {
                id: 'replaceOffer',
                defaultMessage: 'Would you like to replace the offer already in your cart?',
              }
        )}
        showCloseButton
        onDismiss={onClose}
        closeButtonLabelId="keepCurrent"
        closeButtonDefaultMessage="Keep Current"
        actions={
          <ActionButton onPress={onSwap} fullWidth={true} testID="dialog-confirm-btn">
            {formatMessage(
              isReward
                ? { id: 'swapReward', defaultMessage: 'Swap Reward' }
                : { id: 'replace', defaultMessage: 'Replace' }
            )}
          </ActionButton>
        }
        modalAppearanceEventMessage={''}
      />
    )
  );
};
